import { render, staticRenderFns } from "./UserInfoH5.vue?vue&type=template&id=298db2bf&scoped=true&"
import script from "./UserInfoH5.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserInfoH5.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./UserInfoH5.vue?vue&type=style&index=0&id=298db2bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298db2bf",
  null
  
)

export default component.exports